export const color_palette = {
  primary: "#007044",
  secondary: "#ffff",
};

export const app_logo = "";
